import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import 'draft-js/dist/Draft.css';

import {
  Box,
  Stack,
  Typography,
  Tooltip,
  Autocomplete,
  TextField,
  Checkbox
} from '@mui/material';

import { CustomFormLabel } from '../../customComponent';

import { apiList } from '../../../api/callAPI';

import useUser from '../../../hook/useUser';
import useGlobalStatus from '../../../hook/useGlobalStatus';
import useColorSystem from '../../../hook/useColorSystem';

import * as urlConstants from '../../../constants/url';
import * as alertConstants from '../../../constants/alertMsg';

import { MODAL_CREATE_REPORT } from '../../modal/constants';

import {
  HelpOutlineIcon,
  CheckBoxOutlineBlankIcon,
  CheckBoxIcon,
  HighlightOffOutlinedIcon,
  KeyboardArrowDownOutlinedIcon,
} from '../../../constants/images';


const media = 'LINE';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const LineCampaignData = (props) => {
  const {
    selectedAdAccounts,
    getCampaignTarget,
    campaignList,
    setCampaignList,
    selectedCampaign,
    setSelectedCampaign,
    setModalName,
    setIsLoading,
    scrollToAnchor,
  } = props;

  const history = useHistory();
  const { userData, setUserData, setAuthStatusMsg, setAlertMsg } = useUser();
  const { currentActiveData, entryPath, setModalContent, setIsModalOpen } = useGlobalStatus();
  const [allCampaignChecked, setAllCampaignChecked] = useState(false);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const getSelectedCampaign = (allCampaign, selectedCampaignId) => {
    const selectedIdArray = selectedCampaignId.split(",");

    return _.filter(allCampaign, el => _.findIndex(selectedIdArray, c => c === el.id) > -1);
  }

  useEffect(() => {
    setCampaignList([]);
    setSelectedCampaign([]);

    if (entryPath.includes('edit') && selectedAdAccounts.length > 0) {
      setIsLoading(true);
      fetchCampaignData('edit');
    }
  }, [selectedAdAccounts])

  //選擇全部廣告活動
  useEffect(() => {
    if (campaignList.length && selectedCampaign.length === campaignList.length) {
      setAllCampaignChecked(true);
    } else {
      setAllCampaignChecked(false);
    }
  }, [selectedCampaign])

  const changeAllCampaign = (e) => {
    const { checked } = e.target;
    if (checked === true) {
      setAllCampaignChecked(true);
      setSelectedCampaign(campaignList);
    } else {
      setAllCampaignChecked(false);
      setSelectedCampaign([]);
    }
  }

  const fetchCampaignData = (type) => {
    setIsLoading(true);
    setSelectedCampaign([]);
    const adAccountId = selectedAdAccounts.map(el => el.adAccountId);

    if (!adAccountId.length) return;

    apiList.lineGetCampaign({
      cid: adAccountId.toString()
    })
      .then(res => {
        if (res.status === 200) {
          const resData = res.data.result;
          handleCampaignData(resData, type);

        } else if (res.status === 401) {
          setAuthStatusMsg(alertConstants.ERROR_CERTIFICATE);
          setUserData(false);
          history.push(urlConstants.PAGE_LOGIN);
        } else {
          alert(alertConstants.ERROR_SYSTEMCONNECT);
        }
      })
  }

  const handleCampaignData = (resData, type) => {
    let modalName = '';
    let listData = [];
    let selectedData = [];

    if (type === 'create') {
      setModalContent((resData === null || !resData.length) ? { ...MODAL_CREATE_REPORT['checkNoCampaign'], media: media } : { ...MODAL_CREATE_REPORT['checkImportCampaign'], media: media });
      setIsModalOpen(true);
    }

    if (type === 'edit') {
      selectedData = getSelectedCampaign(resData, currentActiveData.conversionsType);
    }

    if (resData !== null && resData.length) {
      listData = resData;
    }

    setModalName(modalName);
    setCampaignList(listData);
    setSelectedCampaign(selectedData);
    setIsLoading(false);
  }

  return (
    <Box mb={5}>
      <Box
        mt={2}
        sx={{ width: '100%' }}
      >
        <Stack variant='between-center'>
          <CustomFormLabel>
            廣告活動
            <Tooltip title="若未勾選，系統預設匯出所有廣告活動">
              <HelpOutlineIcon variant="dark" />
            </Tooltip>
          </CustomFormLabel>
          {
            selectedAdAccounts.length > 0 && entryPath.includes('create') && getCampaignTarget.length > 0 &&
            <Typography
              sx={{
                cursor: 'pointer',
                p: 0,
                marginBottom: '8px',
                color: mainColor
              }}
              onClick={() => fetchCampaignData('create')}
            >
              匯入廣告活動
            </Typography>
          }
        </Stack>

        <Autocomplete
          multiple
          size="small"
          id="selectCampaign"
          options={campaignList}
          groupBy={(option) => option.cidname}
          disableCloseOnSelect={campaignList.length > 1 ? true : false}
          disableClearable={true}
          noOptionsText={"找不到廣告活動"}
          value={selectedCampaign}
          getOptionLabel={(option) => option.name}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
                color={colorMedia}
              />
              {option.name}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              color={colorMedia}
              placeholder={"選擇廣告帳號後可匯入廣告活動"}
            />
          )}
          onChange={(event, newValue) => {
            setSelectedCampaign(newValue);
          }}
          ChipProps={{
            deleteIcon: <HighlightOffOutlinedIcon />
          }}
          popupIcon={<KeyboardArrowDownOutlinedIcon />}
        />
        {
          <CustomFormLabel
            sx={{
              display: 'inline-block',
              mt: '2px',
              cursor: 'pointer',
            }}
            onClick={() => {
              setSelectedCampaign(campaignList)
            }}
          >
            <Checkbox
              size="small"
              name="allCampaign"
              color={colorMedia}
              checked={allCampaignChecked}
              onChange={changeAllCampaign}
              disabled={campaignList.length > 0 ? false : true}
            />
            所有廣告活動
          </CustomFormLabel>
        }
      </Box>
    </Box>
  )
}

export default LineCampaignData;